/**
 * @description Gestion des tailles de textes coupés
 */

/* global activeDot */

(() => {
	setTimeout(() => {
		activeDot();
	}, 200);
})();
